import {
  canShowOwnedResource,
  canShowScopedResource,
  type ResourceScope,
  type ResourceStatus,
} from '../scopedResource';

export const canShowGroupMemberList = ({
  pageOwnerAui,
  listOwnerAui,
  listScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  listOwnerAui: string | null;
  listScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: listOwnerAui,
    resourceScope: listScope,
    currentScope,
    status,
  });

/** GroupMemberTag 목록은 공개 GET /list 하나. owner/public scope 구분 없음. */
export const canShowGroupMemberTagList = ({
  pageOwnerAui,
  listOwnerAui,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  listOwnerAui: string | null;
  status: ResourceStatus;
}): boolean =>
  canShowOwnedResource({
    pageOwnerAui,
    resourceOwnerAui: listOwnerAui,
    status,
  });
